import styled from "styled-components"

import Photo0401 from "../../img/04_01.jpg"
import Photo0402 from "../../img/04_02.jpg"
import Photo0403 from "../../img/04_03.jpg"
import Photo0404 from "../../img/04_04.jpg"
import Photo0405 from "../../img/04_05.jpg"

const ContentBase04 = styled.div`
  background: #111;
  width: 100%;
  height: 100%;
  color: #fff;
  display: flex;
  flex-direction: column;
`
function SubMenuContent04() {
  return (
    <ContentBase04>
      <div className="typobase02">
        K-Shopping은 올레TV모바일을 통해 부가적인 수입을 창출합니다. 커머스
        매체에서 모바일 비중이 높아짐에 따라 모바일앱의 연동은 유용하게
        활용됩니다. 올레TV모바일의 기획전 외에도 K-Shopping Live 영상 웹페이지로
        연동이 가능합니다. 자사의 컨텐츠와 타사의 컨텐츠가 함께 표현되어 디자인
        심의가 까다롭습니다.
      </div>
      <div className="typotitle">Olleh TV Mobile</div>
      <img src={Photo0401} className="photobase" alt="Photo0401"></img>
      <img src={Photo0402} className="photobase" alt="Photo0402"></img>
      <img src={Photo0403} className="photobase" alt="Photo0403"></img>
      <div className="typotitle">Olleh Market</div>
      <img src={Photo0404} className="photobase" alt="Photo0404"></img>
      <img src={Photo0405} className="photobase" alt="Photo0405"></img>
    </ContentBase04>
  )
}

export default SubMenuContent04
